import '@/plugins/lodash';
import '@/plugins/moment';
import '@/plugins/ladda';
import '@/plugins/axios';
import "@/components";
import "./plugins/domArray.js";



import Vue from "vue";
import Vuex from 'vuex';
import Meta from 'vue-meta';
import Notifications from 'vue-notification';
import VueElementLoading from 'vue-element-loading';
import VueApexCharts from 'vue-apexcharts';
import domArray from "./plugins/domArray.js";




import store from '@/store';
import App from "@/views/app";
import i18n from "@/language";
import router from "@/views/router";
import DatePlugin from './plugins/date';







Vue.use(Vuex);
Vue.use(Meta);
Vue.use(Notifications);
Vue.use(VueApexCharts);
Vue.use(domArray);
Vue.use(window);

Vue.component('VueElementLoading', VueElementLoading);
Vue.component('apexchart', VueApexCharts);
Vue.use(DatePlugin);

Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  })


Vue.config.productionTip = false;

router.afterEach((to) => {
          window.currentAction = to.meta?.action || null;
        });
        

new Vue({
    i18n,
    store,
    router,
    render: h => h(App),
    mounted() {
        this.initI18n();
        this.$store.commit('setUser');
        this.$store.commit('setSettings', window.app);
    },
    methods: {
        initI18n() {
            this.$i18n.locale = document.documentElement.lang;
            this.loadTranslations();
        },
        loadTranslations() {
            let self = this;
            /* axios.get('api/lang/' + self.$i18n.locale).then(function (response) {
                
                self.$i18n.setLocaleMessage(self.$i18n.locale, response.data);
            }); */
        },
    },
   
}).$mount("#app");


